module.exports = __webpack_public_path__ + "static/media/ic_device_white.b470d5dd.svg";